import request from '@/utils/request'

let GcardApi = {
    /*列表*/
    gcardlist(data, errorback) {
        return request._post('/shop/gcard.gcard/index', data, errorback);
    },
    /*添加*/
    add(data, errorback) {
        return request._post('/shop/gcard.gcard/add', data, errorback);
    },
    /*修改*/
    edit(data, errorback) {
        return request._post('/shop/gcard.gcard/edit', data, errorback);
    },
    /*修改获取数据*/
    getEdit(data, errorback) {
        return request._get('/shop/gcard.gcard/edit', data, errorback);
    },
    /*删除*/
    del(data, errorback) {
        return request._post('/shop/gcard.gcard/del', data, errorback);
    },

    /**
     * 订单列表
     */
    orderlist(data, errorback) {
        return request._post('/shop/gcard.order/index', data, errorback);
    },
    /*获取基础设置*/
    getData(data, errorback) {
        return request._get('/shop/gcard.setting/index', data, errorback);
    },
    /*保存基础设置*/
    saveData(data, errorback) {
        return request._post('/shop/gcard.setting/index', data, errorback);
    },

  

    
}

export default GcardApi;



// WEBPACK FOOTER //
// ./src/api/gcard.js